import { useEffect, useState } from 'react';
import MessageList from './Message';

const THEME_KEY = 'live-message-theme';

function App() {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const stored = localStorage.getItem(THEME_KEY);
    if (stored === 'light' || stored === 'dark') {
      setTheme(stored);
    }
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('theme-dark');
    } else {
      root.classList.remove('theme-dark');
    }
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  const toggleTheme = () => setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));

  const bgClass =
    theme === 'dark'
      ? 'bg-slate-950'
      : 'bg-gradient-to-br from-white via-slate-50 to-slate-100 text-slate-900';

  return (
    <div className={`relative min-h-screen overflow-hidden ${bgClass} text-foreground`}>
      <div className="pointer-events-none absolute inset-0 -z-10">
        {theme === 'dark' ? (
          <>
            <div className="absolute left-1/4 top-[-10%] h-80 w-80 rounded-full bg-gradient-to-br from-indigo-500/40 via-sky-500/20 to-transparent blur-[120px]" />
            <div className="absolute right-[-10%] top-1/4 h-96 w-96 rounded-full bg-gradient-to-br from-fuchsia-500/30 via-purple-600/20 to-transparent blur-[140px]" />
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(255,255,255,0.06),_transparent_55%)]" />
          </>
        ) : (
          <>
            <div className="absolute left-1/4 top-[-10%] h-80 w-80 rounded-full bg-gradient-to-br from-sky-200/70 via-blue-100/40 to-transparent blur-[120px]" />
            <div className="absolute right-[-10%] top-1/4 h-96 w-96 rounded-full bg-gradient-to-br from-pink-200/50 via-purple-200/40 to-transparent blur-[140px]" />
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(0,0,0,0.04),_transparent_55%)]" />
          </>
        )}
      </div>
      <div className="relative mx-auto max-w-6xl px-4 py-10 sm:px-6 lg:px-8">
        <MessageList theme={theme} onToggleTheme={toggleTheme} />
      </div>
    </div>
  );
}

export default App;
